export default __webpack_public_path__ + "static/feature-discovery-flag-7544f0becd2c1e1f5ed4e9c8f0462739d278842d54c18eccb2b5ff5cf41c9e36.png";